import $ from "jquery";
import _ from "lodash";
import { GlobalWorkerOptions, getDocument, renderTextLayer, } from "pdfjs-dist/legacy/build/pdf.mjs";
import { modal } from "../components/modal";
import { subscribe } from "../events/jQuerySubscription";
GlobalWorkerOptions.workerSrc = "/Assets/js/pdf.worker.js";
const pdfViewerContainer = $("#pdfViewerContainer");
const pdfViewerBackdrop = $("#pdfViewerBackdrop");
const minScale = 0.8;
const maxScale = 2.8;
const scaleStep = 0.1;
let pdf;
let container;
let fullScale;
let currentScale;
const render = async (url, fileName) => {
    const loading = $("#pdf-loading", container);
    loading.addClass("hidden");
    currentScale = fullScale;
    removePages();
    setZoomButtons();
    $("#file-name", container).text(fileName);
    $("#file-download", container).attr("href", url);
    if (url !== (pdf === null || pdf === void 0 ? void 0 : pdf.url)) {
        loading.removeClass("hidden");
        pdf = {
            proxy: await getDocument(url).promise,
            url,
        };
        loading.addClass("hidden");
    }
    await renderPages();
};
const removePages = () => {
    container
        .find("#pdfViewerContent > canvas, #pdfViewerContent > .text-layer")
        .remove();
};
const renderPages = async () => {
    const viewerContent = $("#pdfViewerContent", container);
    for (let pageNumber = 1; pageNumber <= pdf.proxy.numPages; pageNumber++) {
        const page = await pdf.proxy.getPage(pageNumber);
        const templateClone = $("#pdf-canvas-template", container).clone();
        templateClone.removeClass("hidden");
        const canvas = templateClone[0];
        viewerContent.append(canvas);
        const viewport = page.getViewport({ scale: currentScale });
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        await page.render({
            canvasContext: canvas.getContext("2d"),
            viewport,
        }).promise;
        const textLayer = $("<div>")
            .addClass("text-layer")
            .css({
            top: `${canvas.offsetTop - 3}px`,
            left: "1px",
        });
        textLayer[0].style.setProperty("--scale-factor", viewport.scale.toString());
        viewerContent.append(textLayer);
        await renderTextLayer({
            textContentSource: await page.getTextContent(),
            viewport,
            container: textLayer[0],
        }).promise;
    }
};
const onZoomIn = () => {
    if (currentScale < maxScale) {
        currentScale += scaleStep;
        onZoomChanged();
    }
};
const onZoomOut = () => {
    if (currentScale > minScale) {
        currentScale -= scaleStep;
        onZoomChanged();
    }
};
const onZoomFull = () => {
    if (currentScale <= minScale)
        currentScale = fullScale;
    else
        currentScale = minScale;
    onZoomChanged();
};
const onZoomChanged = () => {
    setZoomButtons();
    removePages();
    renderPages();
};
const setZoomButtons = () => {
    const zoomOutButton = $("#zoomout", container)[0];
    const zoomInButton = $("#zoomin", container)[0];
    zoomOutButton.disabled = currentScale <= minScale;
    zoomInButton.disabled = currentScale >= maxScale;
    if (currentScale > minScale) {
        $("#zoom-min-icon", container).removeClass("hidden");
        $("#zoom-max-icon", container).addClass("hidden");
    }
    else {
        $("#zoom-min-icon", container).addClass("hidden");
        $("#zoom-max-icon", container).removeClass("hidden");
    }
};
const showOverlay = () => setTimeout(() => {
    $("body").addClass("noscroll");
    pdfViewerContainer.removeClass("invisible");
});
const hideOverlay = () => setTimeout(() => {
    $("body").removeClass("noscroll");
    pdfViewerContainer.addClass("invisible");
});
$(document).on("click", "[data-toggle='pdf-viewer']", async (e) => {
    const pdfLink = $(e.currentTarget);
    const url = pdfLink.data("pdf-url");
    const filename = pdfLink.data("pdf-filename");
    container = pdfViewerContainer;
    fullScale = 1.7;
    const subscription = subscribe(pdfViewerBackdrop, "click", (e) => {
        if (e.target === pdfViewerBackdrop[0]) {
            hideOverlay();
            subscription.off();
        }
    });
    showOverlay();
    render(url, filename);
});
modal.on("show", (shownModal) => {
    const previewContainer = $("#pdf-preview", shownModal);
    if (!_.some(previewContainer))
        return;
    const url = previewContainer.data("pdf-url");
    const filename = "file";
    container = previewContainer;
    fullScale = 1.2;
    render(url, filename);
});
$(document).on("click", "#zoomin", () => onZoomIn());
$(document).on("click", "#zoomout", () => onZoomOut());
$(document).on("click", "#zoomfull", () => onZoomFull());
$(document).on("click", "#pdfPreviewClose", () => hideOverlay());
